var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { makeApiRequest } from './apiUtils';
function getUserFriendlyErrorMessage(error) {
    // You can customize these messages as needed
    if (typeof error === 'string') {
        // Optionally, check for certain keywords to customize further
        if (error.toLowerCase().includes('network')) {
            return 'Unable to connect. Please check your internet connection and try again.';
        }
        if (error.toLowerCase().includes('timeout')) {
            return 'The request timed out. Please try again later.';
        }
    }
    // Default generic message
    return 'Something went wrong. Please try again later.';
}
var ApiClient = /** @class */ (function () {
    function ApiClient() {
    }
    /**
     * Utility function to retry failed API calls
     * @param fn The async function to retry
     * @param retries Number of retries remaining
     * @param delay Delay between retries in milliseconds
     */
    ApiClient.retry = function (fn_1) {
        return __awaiter(this, arguments, void 0, function (fn, retries, delay) {
            var error_1;
            if (retries === void 0) { retries = ApiClient.MAX_RETRIES; }
            if (delay === void 0) { delay = ApiClient.RETRY_DELAY; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, fn()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        if (retries === 0) {
                            throw error_1;
                        }
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, delay); })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, ApiClient.retry(fn, retries - 1, delay * 2)]; // Exponential backoff
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.fetchData = function (endpoint, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, responseData, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!window.tiofSettings) {
                            throw new Error('tiofSettings not found. Make sure the plugin is properly initialized.');
                        }
                        return [4 /*yield*/, fetch("".concat(window.tiofSettings.restUrl, "/").concat(endpoint), {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json',
                                    'X-WP-Nonce': window.tiofSettings.restNonce
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseData = _a.sent();
                        return [2 /*return*/, responseData];
                    case 3:
                        error_2 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_2)
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch states directly from the API
     * Uses caching to prevent duplicate API calls
     */
    ApiClient.fetchStates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // Return cache if available
                if (ApiClient.statesCache) {
                    return [2 /*return*/, ApiClient.statesCache];
                }
                // If there's an in-flight request, return that promise
                if (ApiClient.statesPromise) {
                    return [2 /*return*/, ApiClient.statesPromise];
                }
                // Otherwise, make a new request
                ApiClient.statesPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_3, fallbackStates;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                if (!((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.restUrl)) {
                                                    throw new Error('API URL not configured. Please check plugin settings.');
                                                }
                                                return [4 /*yield*/, makeApiRequest('states', {
                                                        method: 'GET'
                                                    })];
                                            case 1:
                                                response = _b.sent();
                                                if (!response.success) {
                                                    throw new Error(response.error || 'Failed to fetch states');
                                                }
                                                return [2 /*return*/, response.data || []];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.statesCache = data;
                                return [2 /*return*/, data];
                            case 2:
                                error_3 = _a.sent();
                                ApiClient.statesPromise = null;
                                fallbackStates = ApiClient.getFallbackStates();
                                ApiClient.statesCache = fallbackStates;
                                return [2 /*return*/, fallbackStates];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                return [2 /*return*/, ApiClient.statesPromise];
            });
        });
    };
    /**
     * Get fallback states if API fails
     */
    ApiClient.getFallbackStates = function () {
        return [];
    };
    /**
     * Fetch manufacturers directly from the API
     * Uses caching to prevent duplicate API calls
     */
    ApiClient.fetchManufacturers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // Return cache if available
                if (ApiClient.manufacturersCache) {
                    return [2 /*return*/, {
                            success: true,
                            data: ApiClient.manufacturersCache
                        }];
                }
                // If there's an in-flight request, return that promise
                if (ApiClient.manufacturersPromise) {
                    return [2 /*return*/, ApiClient.manufacturersPromise];
                }
                // Otherwise, make a new request
                ApiClient.manufacturersPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_4, fallbackManufacturers;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, makeApiRequest('manufacturers', {
                                                    method: 'GET'
                                                })];
                                            case 1:
                                                response = _a.sent();
                                                if (!response.success) {
                                                    throw new Error(response.error || 'Failed to fetch manufacturers');
                                                }
                                                return [2 /*return*/, response];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.manufacturersCache = data.data || [];
                                return [2 /*return*/, data];
                            case 2:
                                error_4 = _a.sent();
                                ApiClient.manufacturersPromise = null;
                                fallbackManufacturers = ApiClient.getFallbackManufacturers();
                                ApiClient.manufacturersCache = fallbackManufacturers;
                                return [2 /*return*/, {
                                        success: false,
                                        error: getUserFriendlyErrorMessage(error_4)
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                return [2 /*return*/, ApiClient.manufacturersPromise];
            });
        });
    };
    /**
     * Get fallback manufacturers if API fails
     */
    ApiClient.getFallbackManufacturers = function () {
        return [];
    };
    /**
     * Lookup vehicle by registration number and state
     *
     * @param rego Registration number
     * @param state State ID
     * @returns Promise with vehicle lookup response
     */
    ApiClient.lookupVehicle = function (rego, state, recaptchaToken, stateCode) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchData, error_5;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, makeApiRequest('vehicle/lookup', {
                                            method: 'POST',
                                            body: JSON.stringify({
                                                rego: rego,
                                                state: state,
                                                state_code: stateCode,
                                                recaptcha_token: recaptchaToken
                                            })
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        return [4 /*yield*/, ApiClient.retry(fetchData)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_5)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch years for a manufacturer
     * Uses caching to prevent duplicate API calls for the same manufacturerId
     */
    ApiClient.fetchManufacturerYears = function (manufacturerId) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, promise;
            var _this = this;
            return __generator(this, function (_a) {
                cacheKey = manufacturerId;
                if (ApiClient.yearsCache.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.yearsCache.get(cacheKey)];
                }
                if (ApiClient.yearsPromises.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.yearsPromises.get(cacheKey)];
                }
                promise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_6;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, makeApiRequest('manufacturerYears', {
                                                    method: 'GET',
                                                    queryParams: { manufacturerId: manufacturerId }
                                                })];
                                            case 1:
                                                response = _a.sent();
                                                if (!response.success) {
                                                    throw new Error(response.error || 'Failed to fetch manufacturer years');
                                                }
                                                return [2 /*return*/, response];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.yearsCache.set(cacheKey, data);
                                return [2 /*return*/, data];
                            case 2:
                                error_6 = _a.sent();
                                ApiClient.yearsPromises.delete(cacheKey);
                                return [2 /*return*/, {
                                        success: false,
                                        error: getUserFriendlyErrorMessage(error_6)
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                ApiClient.yearsPromises.set(cacheKey, promise);
                return [2 /*return*/, promise];
            });
        });
    };
    /**
     * Fetch models for a manufacturer and year
     * Uses caching to prevent duplicate API calls
     */
    ApiClient.fetchManufacturerModels = function (manufacturerId, year) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, promise;
            var _this = this;
            return __generator(this, function (_a) {
                cacheKey = "".concat(manufacturerId, "_").concat(year);
                if (ApiClient.modelsCache.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.modelsCache.get(cacheKey)];
                }
                if (ApiClient.modelsPromises.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.modelsPromises.get(cacheKey)];
                }
                promise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_7;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, makeApiRequest('manufacturerModels', {
                                                    method: 'GET',
                                                    queryParams: {
                                                        manufacturerId: manufacturerId,
                                                        year: year
                                                    }
                                                })];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.modelsCache.set(cacheKey, data);
                                return [2 /*return*/, data];
                            case 2:
                                error_7 = _a.sent();
                                ApiClient.modelsPromises.delete(cacheKey);
                                return [2 /*return*/, {
                                        success: false,
                                        error: getUserFriendlyErrorMessage(error_7)
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                ApiClient.modelsPromises.set(cacheKey, promise);
                return [2 /*return*/, promise];
            });
        });
    };
    /**
     * Fetch series for a manufacturer, year and model
     * Uses caching to prevent duplicate API calls
     */
    ApiClient.fetchModelSeries = function (manufacturerId, year, modelId) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, promise;
            var _this = this;
            return __generator(this, function (_a) {
                cacheKey = "".concat(manufacturerId, "_").concat(year, "_").concat(modelId);
                if (ApiClient.seriesCache.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.seriesCache.get(cacheKey)];
                }
                if (ApiClient.seriesPromises.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.seriesPromises.get(cacheKey)];
                }
                promise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_8;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, makeApiRequest('modelSeries', {
                                                    method: 'GET',
                                                    queryParams: {
                                                        manufacturerId: manufacturerId,
                                                        year: year,
                                                        modelId: modelId
                                                    }
                                                })];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.seriesCache.set(cacheKey, data);
                                return [2 /*return*/, data];
                            case 2:
                                error_8 = _a.sent();
                                ApiClient.seriesPromises.delete(cacheKey);
                                return [2 /*return*/, {
                                        success: false,
                                        error: getUserFriendlyErrorMessage(error_8)
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                ApiClient.seriesPromises.set(cacheKey, promise);
                return [2 /*return*/, promise];
            });
        });
    };
    /**
     * Fetch variants for a manufacturer, year, model and series
     * Uses caching to prevent duplicate API calls
     */
    ApiClient.fetchSeriesVariants = function (manufacturerId, year, modelId, seriesId) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, promise;
            var _this = this;
            return __generator(this, function (_a) {
                cacheKey = "".concat(manufacturerId, "_").concat(year, "_").concat(modelId, "_").concat(seriesId);
                if (ApiClient.variantsCache.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.variantsCache.get(cacheKey)];
                }
                if (ApiClient.variantsPromises.has(cacheKey)) {
                    return [2 /*return*/, ApiClient.variantsPromises.get(cacheKey)];
                }
                promise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_9;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, makeApiRequest('seriesVariants', {
                                                    method: 'GET',
                                                    queryParams: {
                                                        manufacturerId: manufacturerId,
                                                        year: year,
                                                        modelId: modelId,
                                                        seriesId: seriesId
                                                    }
                                                })];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.variantsCache.set(cacheKey, data);
                                return [2 /*return*/, data];
                            case 2:
                                error_9 = _a.sent();
                                ApiClient.variantsPromises.delete(cacheKey);
                                return [2 /*return*/, {
                                        success: false,
                                        error: getUserFriendlyErrorMessage(error_9)
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                ApiClient.variantsPromises.set(cacheKey, promise);
                return [2 /*return*/, promise];
            });
        });
    };
    /**
     * Fetch variant options and packs
     * Uses caching to prevent duplicate API calls for the same variantId
     */
    ApiClient.fetchVariantOptionsAndPacks = function (variantId) {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                if (ApiClient.variantOptionsCache.has(variantId)) {
                    return [2 /*return*/, ApiClient.variantOptionsCache.get(variantId)];
                }
                if (ApiClient.variantOptionsPromises.has(variantId)) {
                    return [2 /*return*/, ApiClient.variantOptionsPromises.get(variantId)];
                }
                promise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_10;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    var response;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, makeApiRequest('variantOptionsAndPacks', {
                                                    method: 'GET',
                                                    queryParams: { variantId: variantId }
                                                })];
                                            case 1:
                                                response = _a.sent();
                                                return [2 /*return*/, response];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.variantOptionsCache.set(variantId, data);
                                return [2 /*return*/, data];
                            case 2:
                                error_10 = _a.sent();
                                ApiClient.variantOptionsPromises.delete(variantId);
                                return [2 /*return*/, {
                                        success: false,
                                        error: getUserFriendlyErrorMessage(error_10)
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                ApiClient.variantOptionsPromises.set(variantId, promise);
                return [2 /*return*/, promise];
            });
        });
    };
    /**
     * Fetch vehicle condition questions
     * Uses caching to prevent duplicate API calls
     */
    ApiClient.fetchVehicleConditionQuestions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (ApiClient.conditionQuestionsCache) {
                    return [2 /*return*/, {
                            success: true,
                            data: ApiClient.conditionQuestionsCache
                        }];
                }
                if (ApiClient.conditionQuestionsPromise) {
                    return [2 /*return*/, ApiClient.conditionQuestionsPromise];
                }
                ApiClient.conditionQuestionsPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var fetchData, data, error_11;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, makeApiRequest('vehicleConditionQuestions', {
                                                    method: 'GET'
                                                })];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); };
                                return [4 /*yield*/, ApiClient.retry(fetchData)];
                            case 1:
                                data = _a.sent();
                                ApiClient.conditionQuestionsCache = data.data || [];
                                return [2 /*return*/, data];
                            case 2:
                                error_11 = _a.sent();
                                ApiClient.conditionQuestionsPromise = null;
                                return [2 /*return*/, {
                                        success: false,
                                        error: getUserFriendlyErrorMessage(error_11)
                                    }];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                return [2 /*return*/, ApiClient.conditionQuestionsPromise];
            });
        });
    };
    /**
     * Submit customer details to the server
     *
     * @param customerData The customer details data
     * @returns APIResponse containing success/error information
     */
    ApiClient.submitCustomerDetails = function (customerData) {
        return __awaiter(this, void 0, void 0, function () {
            var error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('customer-details', {
                                method: 'POST',
                                body: JSON.stringify(__assign({ step: 2 }, customerData))
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_12 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_12)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Submit online estimation details to the server
     *
     * @param location The preferred inspection location
     * @param bookingDate The preferred booking date
     * @param bookingTime The preferred booking time
     * @param contactPreference The preferred contact preference
     * @param imageUrls Optional array of uploaded image URLs
     * @returns APIResponse containing success/error information
     */
    ApiClient.submitOnlineEstimation = function (location, bookingDate, bookingTime, contactPreference, imageUrls, priceRangeLow, priceRangeHigh, locationName, noInspection) {
        return __awaiter(this, void 0, void 0, function () {
            var error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('online-estimation', {
                                method: 'POST',
                                body: JSON.stringify({
                                    step: 4,
                                    inspection_location: location,
                                    booking_date: bookingDate ? "".concat(bookingDate.getFullYear(), "-").concat(String(bookingDate.getMonth() + 1).padStart(2, '0'), "-").concat(String(bookingDate.getDate()).padStart(2, '0')) : null,
                                    booking_time: bookingTime,
                                    contact_preference: contactPreference,
                                    image_urls: imageUrls || [],
                                    price_range_low: priceRangeLow,
                                    price_range_high: priceRangeHigh,
                                    inspection_location_name: locationName,
                                    no_inspection: noInspection
                                })
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_13 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_13)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Submit vehicle options and packs selection
     *
     * @param vehicleData The vehicle data including options and packs
     * @returns APIResponse containing success/error information
     */
    ApiClient.submitVehicleOptionsAndPacks = function (vehicleData) {
        return __awaiter(this, void 0, void 0, function () {
            var error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('process-step-one', {
                                method: 'POST',
                                body: JSON.stringify(__assign({ step: 1 }, vehicleData))
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_14 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_14)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Submit vehicle condition information
     *
     * @param conditionData The vehicle condition data
     * @returns APIResponse containing success/error information
     */
    ApiClient.submitVehicleCondition = function (conditionData) {
        return __awaiter(this, void 0, void 0, function () {
            var error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('vehicle-condition', {
                                method: 'POST',
                                body: JSON.stringify(__assign({ step: 3 }, conditionData))
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_15 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_15)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Submit manual vehicle lookup data
     *
     * @param vehicleData The manually selected vehicle data
     * @returns APIResponse containing success/error information
     */
    ApiClient.submitManualLookup = function (vehicleData) {
        return __awaiter(this, void 0, void 0, function () {
            var error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('manual-lookup', {
                                method: 'POST',
                                body: JSON.stringify(__assign({ step: 1, entry_method: 'manual' }, vehicleData))
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_16 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_16)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Submit form data refresh request
     *
     * @returns APIResponse containing success/error information
     */
    ApiClient.refreshFormData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('refresh-data', {
                                method: 'GET'
                            })];
                    case 1:
                        response = _a.sent();
                        // If response was successful but data was wrapped in an array, unwrap it
                        if (response.success && Array.isArray(response.data) && response.data.length === 1) {
                            return [2 /*return*/, __assign(__assign({}, response), { data: response.data[0] })];
                        }
                        return [2 /*return*/, response];
                    case 2:
                        error_17 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: null,
                                error: getUserFriendlyErrorMessage(error_17)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch Available Locations directly from the API
     * Uses caching to prevent duplicate API calls
     */
    ApiClient.fetchAvailableLocations = function (userState) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, error_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryParams = typeof userState !== 'undefined' && userState !== null
                            ? { state: String(userState) }
                            : undefined;
                        return [4 /*yield*/, makeApiRequest('inspection-locations', {
                                method: 'GET',
                                queryParams: queryParams
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_18 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                data: [],
                                error: getUserFriendlyErrorMessage(error_18)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.fetchFinalOfferEstimation = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var apiParams, parseError, error_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        apiParams = void 0;
                        try {
                            apiParams = {
                                SessionID: params.session_id || '',
                                VariantCode: params.variant_code,
                                Odometer: parseInt(params.odometer) || 0,
                                State: parseInt(params.state) || 0,
                                ManufacturingYear: parseInt(params.manufacturing_year) || 0,
                                Rego: params.rego || '',
                                Answers: params.answers ? JSON.parse(params.answers) : [],
                                Options: params.options ? JSON.parse(params.options) : [],
                                Packs: params.packs ? JSON.parse(params.packs) : []
                            };
                        }
                        catch (error) {
                            parseError = error instanceof Error ? error : new Error('Unknown parsing error');
                            throw new Error("Parameter parsing failed: ".concat(parseError.message));
                        }
                        return [4 /*yield*/, makeApiRequest('final-offer-estimation', {
                                method: 'POST',
                                body: JSON.stringify(apiParams)
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_19 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: getUserFriendlyErrorMessage(error_19),
                                data: null
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Check if a rego number already exists in the system
     *
     * @param rego Registration number
     * @param state State ID
     * @returns Promise with check response
     */
    /**
     * Cancel a session
     *
     * @param sessionId The ID of the session to cancel
     * @returns Promise with cancellation response
     */
    ApiClient.cancelSession = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('cancel-session', {
                                method: 'POST',
                                body: JSON.stringify({ session_id: sessionId })
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_20 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: getUserFriendlyErrorMessage(error_20)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient.checkExistingRego = function (rego, state) {
        return __awaiter(this, void 0, void 0, function () {
            var error_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('check-existing-rego', {
                                method: 'POST',
                                body: JSON.stringify({ rego: rego, state: state })
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_21 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: getUserFriendlyErrorMessage(error_21)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Upload vehicle images
     *
     * @param images Array of files to upload
     * @param priceRangeLow Optional minimum price range
     * @param priceRangeHigh Optional maximum price range
     * @returns Promise with upload response containing file URLs
     */
    ApiClient.uploadVehicleImages = function (images, priceRangeLow, priceRangeHigh) {
        return __awaiter(this, void 0, void 0, function () {
            var formData_1, error_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        formData_1 = new FormData();
                        images.forEach(function (img, idx) {
                            formData_1.append('file[]', img);
                        });
                        if (priceRangeLow && priceRangeHigh) {
                            formData_1.append('priceRangeLow', priceRangeLow);
                            formData_1.append('priceRangeHigh', priceRangeHigh);
                        }
                        return [4 /*yield*/, makeApiRequest('vehicle-images', {
                                method: 'POST',
                                body: formData_1,
                                // Don't set Content-Type header for FormData
                                skipContentType: true
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_22 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: getUserFriendlyErrorMessage(error_22)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Submit mini form data
     *
     * @param rego Vehicle registration number
     * @param state State ID
     * @param stateName State name
     * @param stateCode State code (e.g., 'VIC', 'NSW', 'QLD')
     * @returns Promise with submission response
     */
    ApiClient.submitMiniForm = function (rego, state, stateName, stateCode) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, makeApiRequest('mini-form', {
                                method: 'POST',
                                body: JSON.stringify({
                                    entry_method: 'rego',
                                    vehicle_rego: rego,
                                    vehicle_state: state,
                                    vehicle_state_name: stateName,
                                    vehicle_state_code: stateCode
                                })
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_23 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: getUserFriendlyErrorMessage(error_23)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch previous session details
     *
     * @param session_id Session ID
     * @param lastName Last name for verification
     * @param phone Phone number for verification
     * @returns Promise with session details
     */
    ApiClient.fetchPreviousSession = function (session_id_1, lastName_1, phone_1) {
        return __awaiter(this, arguments, void 0, function (session_id, lastName, phone, follow_up) {
            var body, error_24;
            if (follow_up === void 0) { follow_up = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        body = { session_id: session_id };
                        if (lastName)
                            body.last_name = lastName;
                        if (phone)
                            body.phone = phone;
                        if (follow_up)
                            body.follow_up = follow_up;
                        return [4 /*yield*/, makeApiRequest('fetch-previous-session', {
                                method: 'POST',
                                body: JSON.stringify(body)
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_24 = _a.sent();
                        return [2 /*return*/, {
                                success: false,
                                error: getUserFriendlyErrorMessage(error_24)
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Static cache for states
    ApiClient.statesCache = null;
    ApiClient.statesPromise = null;
    // Static cache for manufacturers
    ApiClient.manufacturersCache = null;
    ApiClient.manufacturersPromise = null;
    // Static cache for variant options and packs
    ApiClient.variantOptionsCache = new Map();
    ApiClient.variantOptionsPromises = new Map();
    // Static cache for manufacturer years
    ApiClient.yearsCache = new Map();
    ApiClient.yearsPromises = new Map();
    // Static cache for manufacturer models
    ApiClient.modelsCache = new Map();
    ApiClient.modelsPromises = new Map();
    // Static cache for model series
    ApiClient.seriesCache = new Map();
    ApiClient.seriesPromises = new Map();
    // Static cache for series variants
    ApiClient.variantsCache = new Map();
    ApiClient.variantsPromises = new Map();
    // Static cache for vehicle condition questions
    ApiClient.conditionQuestionsCache = null;
    ApiClient.conditionQuestionsPromise = null;
    // Retry configuration
    ApiClient.MAX_RETRIES = 3;
    ApiClient.RETRY_DELAY = 1000; // 1 second
    return ApiClient;
}());
export { ApiClient };
